import {Injectable} from "@angular/core";
import {Subject, Observable} from "rxjs";


@Injectable()
export class SeccionService{
    private subject = new Subject<any>();

    setSeccion(seccion: any){
        this.subject.next({seccion: seccion.seccion, seccionUrl: seccion.seccionUrl, subseccion: seccion.subseccion});
    }

    getSeccion():Observable<any>{
        return this.subject.asObservable();
    }
}